import { MapTo } from '@adobe/aem-react-editable-components';
import CardActivation, { CardActivationEditConfig } from './CardActivation';

export default MapTo(
    'cob-corp-acquisition/components/creditonebank/card-activation',
)(CardActivation, CardActivationEditConfig);